import {useAxios} from "@/utils/axios";
const $axios = useAxios();

const getCmmnCds = async (seroiCmmnGrpCd) => {
    const {data: cds} = await $axios.get('/api/cmmn/cds', {params: {seroiCmmnGrpCd}});
    return cds;
}

const getYetdYrs = () => {
    const yetdYrs = [
        {cd: '2025', nm: '2025'},
        {cd: '2024', nm: '2024'},
    ];
    return yetdYrs;
}

const useCd = () => {
    return {
        getCmmnCds,
        getYetdYrs
    };
}

export { useCd };
